import { keepPreviousData, useQuery } from "@tanstack/react-query";

import QueryKey from "@app/constants/QueryKeys.ts";
import { SyncAction } from "@app/models/SyncAction.ts";
import { useSyncService } from "@app/services/api/useSyncService.ts";

export const useSyncRuns = (
  page: number,
  size: number,
  action: SyncAction | undefined,
) => {
  const { fetchSyncRuns } = useSyncService();

  const { data, error, isLoading } = useQuery({
    queryKey: [QueryKey.SYNC_RUNS, page, size, action ?? undefined],
    queryFn: () => fetchSyncRuns(page, size, action),
    placeholderData: keepPreviousData,
  });

  return {
    syncRuns: data,
    error,
    isLoading,
  };
};
